import { render } from "./FooterHome.vue?vue&type=template&id=12195d34&scoped=true"
import script from "./FooterHome.vue?vue&type=script&lang=js"
export * from "./FooterHome.vue?vue&type=script&lang=js"

import "./FooterHome.vue?vue&type=style&index=0&id=12195d34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12195d34"]])

export default __exports__